import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigService } from '@app/configuration/config.service';

@Injectable()
export class HttpClientService {
  constructor(private readonly http: HttpClient, private readonly configService: ConfigService) {}

  private get apiUrl(): string {
    return this.configService.getConfig().apiUrl;
  }

  public get<T>(path: string, params = {}, isExternalPath = false): Observable<T> {
    return this.http.get<T>(isExternalPath ? path : `${this.apiUrl}/${path}`, params);
  }

  public put<T>(path: string, body: unknown = {}, params = {}, isExternalPath = false): Observable<T> {
    return this.http.put<T>(isExternalPath ? path : `${this.apiUrl}/${path}`, body, { params });
  }

  /** PUT with full HttpClient options (e.g. headers); `put` only forwards `params`. */
  public putWithOptions<T>(path: string, body: unknown = {}, options: object = {}): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${path}`, body, options);
  }

  public patch<T>(path: string, body: unknown = {}, params = {}, isExternalPath = false): Observable<T> {
    return this.http.patch<T>(isExternalPath ? path : `${this.apiUrl}/${path}`, body, { params });
  }

  public post<T>(path: string, body: unknown = {}, params = {}, isExternalPath = false): Observable<T> {
    return this.http.post<T>(isExternalPath ? path : `${this.apiUrl}/${path}`, body, params);
  }

  public delete<T>(path, options?: unknown): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${path}`, options);
  }
}
